import React from "react";
import Meta from "./Meta";
import { Button, Result } from "antd";
import { getPurOrg } from "../../utils";
import { startPaiement } from "../../services/paiementLauncher";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import { resolveImage } from "./utils";
import Loader from "./loader";
import { onHostUrlReady } from "../../services/embedHost";

export default class LinkMetaRender extends React.Component {
    state = { expired: false };

    componentDidMount() {
        const context = this.props.context;
        const { org, page } = context;

        if (page.linkData?.data?.expired) {
            this.setState({ expired: true });
            return;
        }

        // Un lien court démarre le paiement AU MONTAGE, sans clic : en mode intégré
        // l'adresse de la page hôte n'est pas encore arrivée (elle demande un
        // aller-retour de messages avec le parent). On l'attend brièvement, sinon le
        // donateur reviendrait sur notre site au lieu de celui du client.
        onHostUrlReady(() => {
            switch (page.linkType) {
                // Centralisé : source (APP/WEB) + returnUrl (deep link en app) +
                // sessionStorage + hard redirect (pas de router ici). Cf. paiementLauncher.
                case "PAIEMENT":
                    startPaiement(
                        { ...page.config, organisation: getPurOrg(org) },
                        { org, lang: page.config?.lang, forceReturnUrl: page.config?.returnUrl || org.BASE_WEB_URL }
                    );
                    break;
                case "UPDATE-PAIEMENT":
                    startPaiement(
                        { ...page.config, update: true, organisation: getPurOrg(org) },
                        { org, lang: page.config?.lang }
                    );
                    break;
            }
        });
    }

    render() {
        const context = this.props.context;
        const { org, page } = context;
        const title = page?.meta?.title;
        const description = page?.meta?.description;
        const image = page?.meta?.image ? resolveImage(page.meta.image) : null;

        if (this.state.expired) {
            return (
                <div style={{ minHeight: "50vh", display: "flex", justifyContent: "center", alignItems: "center", padding: 20 }}>
                    <Result
                        style={{ maxWidth: 600 }}
                        status="warning"
                        title={t`Ce lien est expiré !`}
                        subTitle={t`Pour toute question contactez directement votre responsable.`}
                        extra={context.render !== "embed" ? (
                            <Button href={org.BASE_WEB_URL}><Trans>Retourner à la page d'accueil</Trans></Button>
                        ) : undefined}
                    />
                </div>
            );
        }

        return (
            <>
                <Meta seo={{metaTitle:page.meta?.title, metaDescription:page.meta?.description, metaImage:page.meta?.image}} context={context} title={title} description={description} image={image} />
                <div style={{ minHeight: "30vh" }} >
                    <Loader/>
                </div>
            </>
        );
    }
}
